import { PEOPLE_TYPES } from './../presence/types';
export function filterCollection(collection, uuid) {
    return collection.filter((person) => person.uuid !== uuid);
}
export function findPersonType(state, uuid) {
    if (state.doctors.some((person) => person.uuid === uuid)) {
        return PEOPLE_TYPES.doctor;
    }
    if (state.patients.some((person) => person.uuid === uuid)) {
        return PEOPLE_TYPES.patient;
    }
    return null;
}
export function updateOrAddCollection(presenceState, personData, personType = findPersonType(presenceState, personData.uuid)) {
    if (!personType) {
        // no type - do nothing
        return presenceState;
    }
    const prop = `${personType}s`;
    const collection = presenceState[prop];
    if (collection.some((person) => person.uuid === personData.uuid)) {
        return {
            ...presenceState,
            [prop]: presenceState[prop].map((person) => person.uuid !== personData.uuid
                ? person
                : { ...person, state: { ...person.state, ...personData.state } }),
        };
    }
    else {
        const person = { ...personData };
        return {
            ...presenceState,
            [prop]: [...presenceState[prop], person],
        };
    }
}
export function addPerson(presenceState, person) {
    if (!Boolean(person.state)) {
        person.state = {};
    }
    return updateOrAddCollection({
        ...presenceState,
        people: [...presenceState.people, person],
    }, person, person.type);
}
export function handleAddPerson(presenceState, person) {
    const { uuid } = person;
    if (!presenceState.people.some((p) => p.uuid === uuid)) {
        return addPerson(presenceState, person);
    }
    return presenceState;
}
export function removePerson(state, uuid) {
    return {
        ...state,
        people: filterCollection(state.people, uuid),
        doctors: filterCollection(state.doctors, uuid),
        patients: filterCollection(state.patients, uuid),
    };
}
export function updatePerson(presenceState, person) {
    const { state } = person;
    if (!Boolean(state)) {
        // no state - do nothing
        return presenceState;
    }
    return updateOrAddCollection(presenceState, person, person.type);
}
export function forceRemove(state, uuid) {
    return {
        ...state,
        forceRemovedUUIDs: [...state.forceRemovedUUIDs, uuid],
    };
}
